<template>
  <a-drawer
    :title="title"
    :width="width"
    placement="right"
    :closable="false"
    @close="close"
    :visible="visible">
  
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="门店编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['phystoreCode', validatorRules.phystoreCode]" placeholder="请输入门店编号"></a-input>
        </a-form-item>
        <a-form-item label="门店名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['phystoreName', validatorRules.phystoreName]" placeholder="请输入门店名称"></a-input>
        </a-form-item>
        <a-form-item label="门店地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['phystoreAddress', validatorRules.phystoreAddress]" rows="4" placeholder="请输入门店地址"/>
        </a-form-item>
        <a-form-item label="门店地图坐标" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['phystoreCoordinate', validatorRules.phystoreCoordinate]" placeholder="请输入门店地图坐标"></a-input>
        </a-form-item>
        <a-form-item label="门店员工" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-select-user-by-dep v-decorator="['phystoreMembers']"/>
        </a-form-item>
        <a-form-item label="门店负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-select-user-by-dep v-decorator="['phystoreOwner', validatorRules.phystoreOwner]"/>
        </a-form-item>
        <a-form-item label="门店后场打印机" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['phystoreBackendPrinter']" placeholder="请输入门店后场打印机"></a-input>
        </a-form-item>
        <a-form-item label="门店前场打印机" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['phystoreFrontendPrinter']" placeholder="请输入门店前场打印机"></a-input>
        </a-form-item>
        <a-form-item label="销售渠道门店列表" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['phystoreOnlinekey']" rows="4" placeholder="请输入销售渠道门店列表"/>
        </a-form-item>
        <a-form-item label="门店联系电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['phystoreContact']" placeholder="请输入门店联系电话"></a-input>
        </a-form-item>
        
      </a-form>
    </a-spin>
    <a-button type="primary" @click="handleOk">确定</a-button>
    <a-button type="primary" @click="handleCancel">取消</a-button>
  </a-drawer>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
  
  export default {
    name: "SalesPhysicalStoreModal",
    components: { 
      JSelectUserByDep,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          phystoreCode: {
            rules: [
              { required: true, message: '请输入门店编号!'},
            ]
          },
          phystoreName: {
            rules: [
              { required: true, message: '请输入门店名称!'},
            ]
          },
          phystoreAddress: {
            rules: [
              { required: true, message: '请输入门店地址!'},
            ]
          },
          phystoreCoordinate: {
            rules: [
              { required: true, message: '请输入门店地图坐标!'},
            ]
          },
          phystoreOwner: {
            rules: [
              { required: true, message: '请输入门店负责人!'},
            ]
          },
        },
        url: {
          add: "/sales/salesPhysicalStore/add",
          edit: "/sales/salesPhysicalStore/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'phystoreCode','phystoreName','phystoreAddress','phystoreCoordinate','phystoreMembers','phystoreOwner','phystoreBackendPrinter','phystoreFrontendPrinter','phystoreOnlinekey','phystoreContact'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'phystoreCode','phystoreName','phystoreAddress','phystoreCoordinate','phystoreMembers','phystoreOwner','phystoreBackendPrinter','phystoreFrontendPrinter','phystoreOnlinekey','phystoreContact'))
      }
      
    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
</style>